// extracted by mini-css-extract-plugin
export default {"box":"jaEbpwTBEvBxlRY9CZhf","selected":"IUmjfpqip8_9bkWSDnao"};